export const FLOW_RATE = 'flowRate'

export type ByVolumeType = typeof FLOW_RATE

export interface DataPoint {
  x: number
  y: number
}
